import { useEffect } from 'react';
import { usePathname } from '@/lib/router';

// The dashboard shell scrolls an inner container ([data-dashboard-scroll]), not
// the document body. React Router keeps that element mounted across route
// changes, so its scrollTop survives navigation and a new page lands at the
// previous page's offset instead of the top. Reset the active scroller to the
// top whenever the pathname changes.
//
// - Keyed on pathname only: a same-path re-render (state/query update) must NOT
//   yank the user back to the top.
// - `instant`, never `smooth`: the next route is already painting, so a smooth
//   scroll would animate the old page's offset away rather than start at the top.
export function useScrollResetOnNavigate(): void {
  const pathname = usePathname();

  useEffect(() => {
    const scroller = document.querySelector<HTMLElement>('[data-dashboard-scroll]');
    scroller?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
}
